import { render, staticRenderFns } from "./MarketIndex.vue?vue&type=template&id=13372d89&scoped=true&"
import script from "./MarketIndex.vue?vue&type=script&lang=js&"
export * from "./MarketIndex.vue?vue&type=script&lang=js&"
import style0 from "./MarketIndex.vue?vue&type=style&index=0&id=13372d89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13372d89",
  null
  
)

export default component.exports